import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M10.9394 15.2323C11.5251 15.8181 12.4749 15.8181 13.0607 15.2323L19.6464 8.64651C19.8417 8.45124 20.1583 8.45124 20.3536 8.6465C20.5488 8.84177 20.5488 9.15835 20.3536 9.35361L13.7678 15.9394C12.7915 16.9157 11.2086 16.9157 10.2323 15.9394L3.64645 9.35361C3.45119 9.15835 3.45119 8.84177 3.64645 8.64651C3.84171 8.45124 4.15829 8.45124 4.35355 8.6465L10.9394 15.2323Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronBottom;
